// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__2yXBO","overflowing":"ReadFullNote_overflowing__1oVhh"};